import type {SxProps, Theme} from '@mui/material';

import {orangeColors, scorePill, semantic} from '../../../../../layouts/theme/designSystem';
import type {CareerCoachPriorityGap} from '../../types/WorkforceProfileTypes';

export const careerCoachPaperSx: SxProps<Theme> = {
  border: `1px solid ${orangeColors[3]}`,
  borderRadius: '14px',
  p: 2.5,
  mb: 2,
};

export const careerCoachOuterPaperSx: SxProps<Theme> = {
  border: `1px solid ${orangeColors[3]}`,
  borderRadius: '14px',
  overflow: 'hidden',
  p: 0,
};

export const careerCoachSectionLabelSx: SxProps<Theme> = {
  fontWeight: 600,
  color: semantic.info.fg,
};

export const careerCoachResourceLinkSx: SxProps<Theme> = {
  color: semantic.info.fg,
};

export const careerCoachTrendIconSx: SxProps<Theme> = {
  fontSize: 18,
  mt: 0.25,
  color: semantic.info.fg,
};

export const careerCoachMilestoneChipSx: SxProps<Theme> = {
  height: 24,
  fontSize: 12,
  fontWeight: 600,
  bgcolor: scorePill.high.bgcolor,
  color: scorePill.high.color,
  flexShrink: 0,
};

export const getCareerCoachGapTypeColors = (type: CareerCoachPriorityGap['type']) => {
  switch (type) {
    case 'hard_skill':
    case 'knowledge':
      return {bgcolor: semantic.info.bg, color: semantic.info.fg};
    case 'soft_skill':
      return {bgcolor: scorePill.high.bgcolor, color: scorePill.high.color};
    case 'responsibility':
      return {bgcolor: scorePill.low.bgcolor, color: scorePill.low.color};
    case 'core_competency':
    case 'competency':
    default:
      return {bgcolor: scorePill.medium.bgcolor, color: scorePill.medium.color};
  }
};
